"use strict";
// @ts-nocheck
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
exports.__esModule = true;
var React = __importStar(require("react"));
;
function plr(_a) {
    var size = _a.size, _b = _a.color, color = _b === void 0 ? "currentColor" : _b;
    return React.createElement("svg", { width: size, height: size, viewBox: "0 0 24 24", fill: "none" },
        React.createElement("path", { d: "M6.3075 15.6765H6.234V18.75H4.5V8.34375H6.195V8.82375H6.26175C6.8535 8.25675 7.60725 8.241 8.03025 8.241C9.80325 8.241 10.9658 9.93075 10.9658 12.1875V12.48C10.9658 14.8282 9.62025 16.2277 8.00025 16.2277C7.242 16.23 6.68025 16.0568 6.3075 15.6765ZM9.3555 12.6195V12.1072C9.3555 10.6372 8.79525 9.654 7.797 9.654C6.7185 9.654 6.14025 10.797 6.14025 12.1072V12.6172C6.14025 13.866 6.7095 14.8223 7.827 14.8223C8.70675 14.8193 9.3555 14.1337 9.3555 12.6195ZM11.805 5.25H13.5413V16.182H11.805V5.25ZM18.5018 10.0568C17.5283 10.0568 16.5615 10.8293 16.5615 11.8057V16.1887H14.835V8.41725H16.4347V8.895H16.5C16.8885 8.4855 17.8387 8.2935 18.6202 8.30475C18.6982 8.30475 18.6337 8.307 18.7095 8.307L18.7185 10.0568H18.5018ZM17.7728 14.3212H19.5V16.182H17.7728V14.3212Z", fill: color }));
}
exports["default"] = plr;
//# sourceMappingURL=plr.js.map